import { createActionGroup, props } from '@ngrx/store';

import { GatewayId } from '../../models/gateway';

export const SiteGatewayDetailPageActions = createActionGroup({
    source: 'Site Gateway Detail Page',
    events: {
        opened: props<{ gatewayId: GatewayId }>(),
    },
});
